import { render, staticRenderFns } from "./ProdutoInfo.vue?vue&type=template&id=23da25a5"
import script from "./ProdutoInfo.vue?vue&type=script&lang=js"
export * from "./ProdutoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports